import React, { memo } from "react";
import clsx from "clsx";
import { shallowEqual } from "react-redux";
import { getAemMonthlyRateFormat } from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { useCarConfigSelector } from "../../../../redux/store";
import { AemFmComponent } from "../../../../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";
import type { CommonFinanceInfoType, PriceType } from "../../../../../../../common-deprecated/types/CommonTypes";
import {
    CommonMonthlyPriceLabelKey,
    type FormatMonthlyPriceType,
} from "../../../../../../../common-deprecated/priceUtils";
import PromotionNumbers from "./PromotionNumbers";
import styles from "./CashPrice.module.scss";
import { showCarConfigMonthlyRateSelector } from "../../../../utils/selectorUtils";
import { formatMonthlyFinancePrice } from "../../../../../shared-logic/utils/priceUtils";

type MonthlyPriceType = {
    price: PriceType;
    financeInfo: CommonFinanceInfoType;
    modelCode?: string;
    showZeroPrice?: boolean;
};

const MonthlyPrice = (props: MonthlyPriceType): JSX.Element | null => {
    const { price, financeInfo, modelCode, showZeroPrice = false } = props;
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const monthlyEnabled = useCarConfigSelector(showCarConfigMonthlyRateSelector, shallowEqual);

    if (!monthlyEnabled) return null;
    if (!price.monthly && !showZeroPrice) return null;
    const promotions = price.promotions.concat(price.onlineMonthlyPromotions);

    const monthlyPriceFormat = getAemMonthlyRateFormat(commonSettings, AemFmComponent.Carconfig, "new", modelCode);
    const { labels = [] } = financeInfo
        ? formatMonthlyFinancePrice<FormatMonthlyPriceType>(
              price,
              financeInfo,
              commonSettings,
              monthlyPriceFormat,
              showZeroPrice,
          )
        : { labels: [] };

    return (
        <span className={clsx(styles.pricewrapper, promotions.length > 0 && styles.flex)}>
            {labels.map(({ key, value }) => (
                <span key={key}>
                    {key === CommonMonthlyPriceLabelKey.Price && <span dangerouslySetInnerHTML={{ __html: value }} />}
                </span>
            ))}{" "}
            {promotions.length > 0 && <PromotionNumbers promotions={promotions} />}
        </span>
    );
};

export default memo(MonthlyPrice);
